module.exports = __webpack_public_path__ + "img/circle.adbe25e4.svg";